export const Maintenance = () => {
  return (
    <div className="bg-[#F1F6FC] flex flex-1 min-h-screen items-center justify-center px-4 py-10">
      <div className="rounded shadow-md bg-white flex flex-col items-center py-10 px-6 md:px-16 max-w-xl w-full">
        <img src="/img/dupr_dark.svg" alt="DUPR" className="h-10 mb-8" />
        <h1 className="text-navy-900 text-3xl md:text-4xl font-bold text-center leading-tight">
          We&rsquo;ll be right back
        </h1>
        <p className="mt-4 text-center text-[#757895] font-medium">
          DUPR is down for scheduled maintenance. We&rsquo;re making some improvements and will be back online shortly.
        </p>
        <p className="mt-2 text-center text-[#757895] font-medium">Thanks for your patience.</p>
        <p className="mt-6 text-center text-[#757895] font-medium">
          Need help? Contact{' '}
          <a
            href="https://dupr.zendesk.com/hc/en-us/requests/new?ticket_form_id=26010354856852"
            target="_blank"
            rel="noreferrer"
            className="text-primary-500"
          >
            support@mydupr.com
          </a>
        </p>
      </div>
    </div>
  )
}
